import { Layout, Select, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import eventBus from '../utils/eventBus';
import { fetchFinancialYearList, changeFinancialYear, resetFinancialYearData } from '../slices/financial-year';

const { Header } = Layout;

export default function AppHeader() {
  const dispatch = useDispatch();
  const { data = [] } = useSelector(state => state.financialYear);
  const [selectedYear, setSelectedYear] = useState(null);

  useEffect(() => {
    dispatch(fetchFinancialYearList({ page: 1, pagesize: 1000 }));
  }, [dispatch]);

  useEffect(() => {
    // ✅ Find the one marked as current
    if (data.length > 0) {
      const currentYear = data?.find((item) => item.current === true);
      if (currentYear) {
        setSelectedYear(currentYear.fid); // or item.id if using "id"
      }
    }
  }, [data]);

  const handleChange = async (value) => {

    try {
      dispatch(changeFinancialYear(value))
        .unwrap()
        .then((response) => {
          if (response.success) {
            message.success(response?.message);
            dispatch(resetFinancialYearData());
            dispatch(fetchFinancialYearList({ page: 1, pagesize: 1000 }));
            eventBus.emit("financialYear:refresh")
          }
        })
        .catch((err) => {
          console.error('Delete Error:', err);
          // message.error(`Error: ${err.message || 'Failed to delete the profile.'}`);
        });
    } catch (err) {
      //message.error("Failed to update financial year");
      console.error(err);
    }
  };

  return (
    <Header>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <Select
          style={{ width: 200 }}
          placeholder="Select Financial Year"
          value={selectedYear}
          onChange={handleChange}
        >
          {data?.map((item, index) => (
            <Select.Option key={index} value={item?.fid}>
              FY {item.financial_year}
            </Select.Option>
          ))}
        </Select>
        {/* <Dropdown
          className="addmenu"
          menu={{
            items,
          }}
          trigger={['click']}
          placement="bottomRight"
        >
          <Link>
            <PlusOutlined />
            </Link>
        </Dropdown>
        <Dropdown menu={{ items: userMenuItems }} trigger={['click']} className="usermenu">
          <div
            style={{
              gap: '5px',
            }}
          >
              {currentUser && (<Avatar className="ant-avatar" src={currentUser.profile_image === '' ? profilePic : currentUser.profile_image} /> )}
              {currentUser && (<span style={{marginRight: '4px', fontWeight: '600'}}>
                {currentUser.first_name} {currentUser.last_name}
            </span> )}
            <DownOutlined />
          </div>
        </Dropdown>

        <Button
          type="link"
          shape="circle"
          className="btnicon"
          onClick={showLogoutConfirm}
        >
          <LogoutOutlined />
        </Button> */}
      </div>
    </Header>
  );
}
